const emailPattern = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
const invalidEmailPattern = /\.\./;

export function verifyProperEmail(email: string): boolean {
  return emailPattern.test(email) && !invalidEmailPattern.test(email);
}